//post data
import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios';
import Style from './App.css'
import Logo from './imgs/nareppo.png'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function MyLoginScreen(params) {
  const [userName, setUserName] = useState("akkaradmin@akkarlojistik.com.tr");
  const [passWord, setPassWord] = useState("39e89eb6b9fa795df8b33686dae76e04");

  function getMyCredential(event) {
    event.preventDefault();
    let basurl = window.location.hostname
    const url1 = `http://${basurl}:9091/api/User/getAccessToken`
    axios.get(url1, {
      params: {
        email: userName,
        password:passWord
      }
    })
      .then(res => {
        console.log('res.data',res.data);
        if(res.data&&res.data.token){
          window.localStorage.setItem("token",res.data.token);
          window.localStorage.setItem("company",res.data.company);
          window.localStorage.setItem("userType",res.data.userType);
          window.location.href = res.data.userType=='614a72993114ba2ecdc55d09'?`/MyOrdersScreen/`:`/MyCustomerDeliveryReport/`;
        } else {
          toast.error(`Kullanıcı adı ya da şifre hatalı. Kontrol edip lütfen tekrar deneyin!`);
        }
      })
      .catch(err => {
        toast.error(`Kullanıcı adı ya da şifre hatalı. Kontrol edip lütfen tekrar deneyin ya da sistem yoneticinizle iletisime gecin!`);
        console.log(err.response.data);
      });
  }

  return (
    <div clasName="FormLogin">
      <ToastContainer draggable pauseOnHover newestOnTop={true} position="top-center" />
      <div className="bg-img">
        <div class="bird-container bird-container--one">
          <div class="bird bird--one"></div>
        </div>
        <div class="bird-container bird-container--two">
          <div class="bird bird--two"></div>
        </div>
        <div class="bird-container bird-container--three">
          <div class="bird bird--three"></div>
        </div>
        <div class="bird-container bird-container--four">
          <div class="bird bird--four"></div>
        </div>

        <form className="container">
          <div class="clearfix float-my-children">
            <img src={Logo} style={{ height: "100px", width: "100px" }} />
          </div><br></br>
          <input type="text" name="userName" value={userName} onChange={e => setUserName(e.target.value)} placeHolder="Emailinizi Giriniz" required /> <br></br>
          <input type="password" name="passWord" value={passWord} onChange={e => setPassWord(e.target.value)} placeHolder="Şifrenizi Giriniz" required></input> <br></br>
          <button type="submit" onClick={getMyCredential} value="Submit" className="btn">Giriş</button>
        </form>
      </div>
    </div>
  )
}

export default MyLoginScreen;